<template>
  <ValidationProvider
    :name="valid.name"
    :rules="valid.rules"
    v-slot="{ errors }"
    tag="div"
    class="input-box"
  >
    <p v-show="title">{{ title }}</p>
    <v-text-field
      v-model="innerValue"
      outlined
      dense
      hide-details
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :error="errors.length > 0"
      :tabindex="tabindex"
      :autofocus="autofocus"
      :oninput="innerOninput"
      :type="innerType"
      @input="$emit('update:inputValue', $event)"
    >
      <template v-if="clearable" v-slot:append>
        <v-fade-transition>
          <img
            v-if="inputValue"
            src="@/assets/images/icons/clear.svg"
            @click="$emit('update:inputValue', '')"
          />
        </v-fade-transition>
      </template>

      <template v-else-if="type === 'password'" v-slot:append>
        <div @click="$emit('update:passwordShow', !passwordShow)">
          <v-fade-transition group hide-on-leave>
            <img v-if="passwordShow" src="@/assets/images/icons/eye-close.svg" key="close" />
            <img v-else src="@/assets/images/icons/eye-open.svg" key="open" />
          </v-fade-transition>
        </div>
      </template>
    </v-text-field>
    <v-slide-y-transition>
      <p v-if="errors.length > 0">{{ errors[0] }}</p>
    </v-slide-y-transition>
  </ValidationProvider>
</template>

<script>
function phoneInput() {
  this.value = this.value
    .replace(/[^0-9.]/g, '')
    .replace(/(..*)./g, '$1')
    .substring(0, 11)
}

export default {
  props: {
    inputValue: {
      type: String,
      default: '',
    },
    passwordShow: {
      type: Boolean,
      default: null,
    },

    /**
     * {
     *   name: 'email',
     *   rules: 'required|email|email_duplicate'
     * }
     */
    valid: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    tabindex: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    oninput: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      innerValue: this.inputValue,
    }
  },
  watch: {
    inputValue: {
      handler(v) {
        this.innerValue = v
      },
      immediate: true,
    },
  },
  computed: {
    innerType() {
      if (this.type !== 'password') return this.type

      return this.passwordShow ? 'text' : 'password'
    },
    innerOninput() {
      if (this.oninput) return this.oninput

      if (this.valid?.name?.indexOf('password') > -1)
        return 'this.value = this.value.substring(0,16)'

      return null
    },
  },
}
</script>
